import { render, staticRenderFns } from "./AverageTimeWidget.vue?vue&type=template&id=2dd5ecb7&"
import script from "./AverageTimeWidget.vue?vue&type=script&lang=js&"
export * from "./AverageTimeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports